/* eslint-disable */
import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Box from '@mui/material/Box';
import { TableSortLabel } from '@mui/material';
import _ from 'lodash';
import { visuallyHidden } from '@mui/utils';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EditAccountManagementSuperAdmin from './AccountManagement/EditAccountManagementSuperAdmin';
import DeleteAccountManagementSuperAdmin from './AccountManagement/DeleteAccountManagementSuperAdmin';

const columns = [
  {
    id: 'id',
    label: 'ลำดับที่',
    align: 'left',
  },
  {
    id: 'username',
    label: 'ผู้ใช้',
    align: 'left',
  },
  {
    id: 'email',
    label: 'อีเมลล์',
    align: 'left',
  },
  {
    id: 'action',
    label: ' ',
    align: 'center',
    minWidth: 200,
  },
];

function TableManagementSuperAdmin({
  isManagementSuperAdmin,
  pagination,
  handlePaginationChange,
}) {
  const [page, setPage] = useState(pagination.currPage - 1);
  const [rowsPerPage, setRowsPerPage] = useState(pagination.size);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    handlePaginationChange('handleChangePage', newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setRowsPerPage(newSize);
    setPage(0);
    handlePaginationChange('handleChangeRowsPerPage', newSize);
  };

  const [editAccountData, setEditAccountData] = useState(null);
  const [deleteAccountData, setDeleteAccountData] = useState(null);

  const handleOpenEditAccountManagementPopupOpen = (data) => {
    setEditAccountData(data);
  };
  const handleOpenDeleteAccountManagementPopupOpen = (data) => {
    setDeleteAccountData(data);
  };

  const handleCloseEditAccountManagementPopupOpen = () => {
    setEditAccountData(null);
  };
  const handleCloseDeleteAccountManagementPopupOpen = () => {
    setDeleteAccountData(null);
  };

  return (
    <>
      <TableContainer sx={{ maxHeight: 460, overflowY: 'auto' }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, color: '#fff' }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {_.size(isManagementSuperAdmin) ? (
            <TableBody>
              {isManagementSuperAdmin
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                    }}
                    className="hover:bg-gray-200 cursor-pointer"
                  >
                    <TableCell align="left">
                      {index + 1 ? index + 1 : '-'}
                    </TableCell>
                    <TableCell align="left">
                      {row.username ? row.username : '-'}
                    </TableCell>
                    <TableCell align="left">
                      {row.email ? row.email : '-'}
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        sx={{ color: '#F4BA27' }}
                        onClick={() =>
                          handleOpenEditAccountManagementPopupOpen(row)
                        }
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        sx={{ color: '#FC3A3A' }}
                        onClick={() =>
                          handleOpenDeleteAccountManagementPopupOpen(row)
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colSpan={10} align="center">
                  <div>ไม่มีข้อมูล</div>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={pagination.total}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {editAccountData && (
        <EditAccountManagementSuperAdmin
          open={Boolean(editAccountData)}
          onClose={handleCloseEditAccountManagementPopupOpen}
          data={editAccountData}
        />
      )}
      {deleteAccountData && (
        <DeleteAccountManagementSuperAdmin
          open={Boolean(deleteAccountData)}
          onClose={handleCloseDeleteAccountManagementPopupOpen}
          deleteId={deleteAccountData}
        />
      )}
    </>
  );
}

export default TableManagementSuperAdmin;
